<div class="p-5 max-w-full bg-transparent rounded-lg">
  <tree-selector (changeSelectedMaterialNames)="changeSelectedMaterials($event)"></tree-selector>

  <!-- 이미지 업로드 영역 -->
  <div class="my-6">
    @if (!uploadedImage) {
      <div
        class="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-lg p-10 text-center cursor-pointer transition-all duration-300 hover:border-black dark:hover:border-white hover:bg-gray-100 dark:hover:bg-gray-800 relative"
        (click)="onUploadClick()"
      >
        <div class="w-12 h-12 mx-auto mb-4 text-black dark:text-white">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7,10 12,15 17,10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
        </div>
        <p class="text-base font-medium text-black dark:text-white mb-2">
          이미지를 업로드하려면 클릭하세요
        </p>
        <p class="text-sm text-gray-600 dark:text-gray-400">또는 이미지를 여기로 드래그하세요</p>
        <input
          type="file"
          #fileInput
          (change)="onFileSelected($event)"
          accept="image/*"
          class="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
        />
      </div>
    }
    @if (uploadedImage) {
      <div class="relative w-full aspect-square inline-block">
        <button
          class="absolute top-2 right-2 w-6 lg:w-10 h-6 lg:h-10 rounded-full p-1 flex justify-center items-center bg-white/60 dark:bg-black/60 z-[20]"
          (click)="removeImage()"
        >
          <div
            class="flex justify-center items-center text-black dark:text-white text-base lg:text-xl"
          >
            <mat-icon [inline]="true">restart_alt</mat-icon>
          </div>
        </button>
        <img
          [src]="uploadedImage"
          alt="업로드된 이미지"
          class="w-full h-full object-contain rounded-lg border border-gray-300 dark:border-gray-600"
        />
      </div>
    }
  </div>
</div>
